/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sidebar_TitleInputs */

const en_common_sidebar_title = /** @type {(inputs: Common_Sidebar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidebar`)
};

const es_common_sidebar_title = /** @type {(inputs: Common_Sidebar_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barra lateral`)
};

/**
* | output |
* | --- |
* | "Sidebar" |
*
* @param {Common_Sidebar_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_sidebar_title = /** @type {((inputs?: Common_Sidebar_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sidebar_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sidebar_title(inputs)
	return es_common_sidebar_title(inputs)
});